import React from 'react';

const styles = {
  root: {
    margin: 0,
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    background: '#0a0a0a',
    color: '#fafafa',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: 'clamp(1.5rem, 5vw, 2.25rem)',
    fontWeight: 600,
    margin: 0,
    letterSpacing: '-0.02em',
  },
  text: {
    margin: '1rem 0 2rem',
    fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
    color: 'rgba(250, 250, 250, 0.7)',
    lineHeight: 1.6,
  },
  link: {
    display: 'inline-block',
    padding: '0.875rem 1.75rem',
    background: '#fafafa',
    color: '#0a0a0a',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: 600,
    fontSize: '1rem',
    transition: 'opacity 0.15s ease',
  },
};

function App() {
  return (
    <div style={styles.root}>
      <h1 style={styles.title}>This project has moved</h1>
      <p style={styles.text}>It’s now at a new domain.</p>
      <a
        href="https://papervault.xyz"
        style={styles.link}
        onMouseOver={(e) => (e.target.style.opacity = '0.85')}
        onMouseOut={(e) => (e.target.style.opacity = '1')}
      >
        Go to papervault.xyz
      </a>
    </div>
  );
}

export default App;
